import React, { useEffect } from 'react'
import { Dialogs, useDialogs } from '../Contexts/DialogsContext'
import { useGlobalContext } from '../Contexts/GlobalContext'
import { LoginState } from '../globalHeader/GlobalHeader'

const DialogService: React.FC = () => {
    const { loginState, isGuest } = useGlobalContext()
    const { dialogs, dialogRegistry, unregisterDialog, pauseDialogs } = useDialogs()

    // Unregister dialogs by restrictions
    useEffect(() => {
        if (dialogs.length > 0) {
            if (dialogRegistry[Dialogs.SIGNIN] && loginState === LoginState.LOGGED_IN && !isGuest) {
                unregisterDialog(Dialogs.SIGNIN)
            }
            if (dialogRegistry[Dialogs.SIGNUP] && loginState === LoginState.LOGGED_IN && !isGuest) {
                unregisterDialog(Dialogs.SIGNUP)
            }
            if (dialogRegistry[Dialogs.SETTINGS] && loginState !== LoginState.LOGGED_IN) {
                unregisterDialog(Dialogs.SETTINGS)
            }
        }
    }, [dialogs, isGuest, loginState])

    if (pauseDialogs) {
        return null
    }

    return (
        <>
            {/* {dialogs.map((dialog, index) => (
                <React.Fragment key={index}>{dialog}</React.Fragment>
            ))} */}

            {dialogs[0] && <React.Fragment key={0}>{dialogs[0]}</React.Fragment>}
        </>
    )
}

export default DialogService
